// src/translations/en.ts

const en: Record<string, string> = {
  // Common
  'common.loading': 'Loading...',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.add': 'Add',
  'common.confirm': 'Confirm',
  'common.refresh': 'Refresh',
  'common.search': 'Search',
  'common.all': 'All',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.back': 'Back',
  'common.close': 'Close',
  'common.actions': 'Actions',
  'common.status': 'Status',
  'common.name': 'Name',
  'common.description': 'Description',
  'common.price': 'Price',
  'common.currency': 'IQD',
  'common.noDescription': 'No description',
  'common.confirmDelete': 'Confirm Delete',
  'common.cannotUndo': 'This action cannot be undone.',
  'common.selected': 'selected',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.sorry': 'Sorry!',
  'common.minutes': 'm',
  'common.minute': 'minute',
  'common.table': 'Table',
  'common.tableNumber': 'Table Number',
  'common.free': 'Free',
  'common.print': 'Print',

  // Messages
  'messages.success.login': 'Logged in successfully',
  'messages.success.logout': 'Logged out successfully',
  'messages.success.created': 'Created successfully',
  'messages.success.updated': 'Updated successfully',
  'messages.success.deleted': 'Deleted successfully',
  'messages.error.generic': 'Something went wrong. Please try again',
  'messages.error.unauthorized': 'Unauthorized. Please log in',
  'messages.error.network': 'Server connection error',
  'messages.error.validation': 'Please check the entered data',

  // Sidebar
  'sidebar.systemAdmin': 'System Admin',
  'sidebar.restaurant': 'Restaurant',
  'sidebar.dashboard': 'Statistics',
  'sidebar.restaurantProfile': 'Restaurant Profile',
  'sidebar.settings': 'Settings',
  'sidebar.orders': 'Orders',
  'sidebar.tables': 'Tables',
  'sidebar.categories': 'Categories',
  'sidebar.dishes': 'Dishes',
  'sidebar.scheduling': 'Scheduling',
  'sidebar.addDish': 'Add Dish',
  'sidebar.logout': 'Logout',
  'sidebar.adminDashboard': 'Dashboard',
  'sidebar.restaurants': 'Restaurants',
  'sidebar.addRestaurant': 'Add Restaurant',
  'sidebar.language': 'Language',
  'sidebar.cashier': 'Cashier',
  'sidebar.inventory': 'Inventory',
  'sidebar.templates': 'Preparation Templates',
  'sidebar.profile': 'Profile',

  // Navbar
  'nav.dashboard': 'Dashboard',
  'nav.login': 'Login',
  'nav.loginShort': 'Login',
  'nav.logout': 'Logout',
  'nav.systemAdmin': 'System Admin',
  'nav.restaurantOwner': 'Restaurant Owner',
  'nav.services': 'Services',
  'nav.about': 'About',
  'nav.partners': 'Partners',

  // Auth / Login
  'auth.welcomeBack': 'Welcome Back',
  'auth.loginSubtitle': 'Log in to access the dashboard',
  'auth.emailOrUsername': 'Username or Email',
  'auth.password': 'Password',
  'auth.loginButton': 'Login',
  'auth.loginFailed': 'Login failed. Please check your credentials',
  'auth.backToHome': 'Back to Home',
  'auth.demoAccounts': 'Demo Accounts:',
  'auth.adminAccount': 'Admin Account',
  'auth.restaurantAccount': 'Restaurant Account',
  'auth.menuSystem': 'Menu Management System',

  // Dashboard
  'dashboard.title': 'Statistics',
  'dashboard.adminTitle': 'Admin Dashboard',
  'dashboard.welcome': 'Welcome,',
  'dashboard.welcomeMessage': 'Welcome to the Dashboard',
  'dashboard.loading': 'Loading dashboard...',
  'dashboard.loadingStats': 'Loading statistics...',
  'dashboard.revenue': 'Revenue',
  'dashboard.totalOrders': 'Total Orders',
  'dashboard.totalRestaurants': 'Total Restaurants',
  'dashboard.totalDishes': 'Total Dishes',
  'dashboard.activeRestaurants': 'Active Restaurants',
  'dashboard.restaurantOwners': 'Restaurant Owners',
  'dashboard.completedOrders': 'Completed Orders',
  'dashboard.cancelledOrders': 'Cancelled Orders',
  'dashboard.copyLink': 'Copy Link',
  'dashboard.copied': 'Copied!',
  'dashboard.viewMenu': 'View Menu',
  'dashboard.filterData': 'Filter Data',
  'dashboard.choosePeriod': 'Choose Time Period',
  'dashboard.today': 'Today',
  'dashboard.thisWeek': 'This Week',
  'dashboard.thisMonth': 'This Month',
  'dashboard.thisYear': 'This Year',
  'dashboard.customPeriod': 'Custom Period',
  'dashboard.fromDate': 'From Date',
  'dashboard.toDate': 'To Date',
  'dashboard.applyFilter': 'Apply Filter',
  'dashboard.linkCopied': 'Menu link copied successfully!',

  // Profile
  'profile.loading': 'Loading profile...',
  'profile.loadFailed': 'Failed to load restaurant data',
  'profile.editProfile': 'Edit Profile',
  'profile.allDishes': 'All Dishes',
  'profile.otherDishes': 'Other Dishes',
  'profile.unavailable': 'Unavailable',
  'profile.noDishesInCategory': 'No dishes in this category',
  'profile.addDishesHint': 'Add new dishes from the dashboard',
  'profile.loadingData': 'Loading restaurant data...',
  'profile.backToProfile': 'Back to Profile',
  'profile.editTitle': 'Edit Profile',
  'profile.updateInfo': 'Update your restaurant info and images',

  // Categories
  'categories.title': 'Manage Categories',
  'categories.subtitle': 'Add and organize your menu categories • Drag to reorder',
  'categories.addCategory': 'Add Category',
  'categories.addNewCategory': 'Add New Category',
  'categories.editCategory': 'Edit Category',
  'categories.categoryName': 'Category Name',
  'categories.displayOrder': 'Display Order',
  'categories.displayOrderHint': 'Used to order categories in the menu',
  'categories.saveChanges': 'Save Changes',
  'categories.totalCategories': 'Total Categories',
  'categories.totalDishes': 'Total Dishes',
  'categories.noCategories': 'No categories yet',
  'categories.startAdding': 'Start by adding the first category to your menu',
  'categories.loadingCategories': 'Loading categories...',
  'categories.loadFailed': 'Failed to load categories',
  'categories.createSuccess': 'Category added successfully',
  'categories.updateSuccess': 'Category updated successfully',
  'categories.deleteSuccess': 'Category deleted successfully',
  'categories.saveFailed': 'Failed to save category',
  'categories.deleteFailed': 'Failed to delete category',
  'categories.reorderSuccess': 'Category order updated successfully',
  'categories.reorderFailed': 'Failed to update order',
  'categories.deleteConfirm': 'Are you sure you want to delete the category',
  'categories.deleteWarning': 'All dishes in this category will be moved to "Uncategorized".',
  'categories.deleteCategory': 'Delete Category',
  'categories.dish': 'dish',
  'categories.order': 'Order',
  'categories.dishCount': 'Dishes Count',
  'categories.createdAt': 'Created At',

  // Dishes
  'dishes.title': 'Manage Dishes',
  'dishes.subtitle': 'View and manage all dishes',
  'dishes.dishCount': 'dish',
  'dishes.addDish': 'Add Dish',
  'dishes.addNewDish': 'Add New Dish',
  'dishes.totalDishes': 'Total Dishes',
  'dishes.available': 'Available',
  'dishes.unavailable': 'Unavailable',
  'dishes.categoriesCount': 'Categories',
  'dishes.searchPlaceholder': 'Search for a dish...',
  'dishes.category': 'Category',
  'dishes.noCategoryFilter': 'Uncategorized',
  'dishes.dishList': 'Dishes List',
  'dishes.availableDishes': 'dish available',
  'dishes.dish': 'Dish',
  'dishes.section': 'Category',
  'dishes.statusLabel': 'Status',
  'dishes.loadingDishes': 'Loading dishes...',
  'dishes.noDishes': 'No dishes',
  'dishes.startAdding': 'Start by adding dishes to your menu',
  'dishes.deleteConfirm': 'Are you sure you want to delete the dish',
  'dishes.deleteDish': 'Delete Dish',
  'dishes.setAvailable': 'Set as Available',
  'dishes.setUnavailable': 'Set as Unavailable',
  'dishes.clearSelection': 'Clear Selection',
  'dishes.updateStatus': 'Update Status',
  'dishes.bulkStatusConfirm': 'Do you want to update the status of',
  'dishes.bulkStatusTo': 'dish(es) to',
  'dishes.pausedUntil': 'Paused until',
  'dishes.preview': 'Preview',
  'dishes.quickPause': 'Quick Pause',
  'dishes.pause': 'Pause',
  'dishes.pauseDishDesc': 'Temporarily pause this dish',
  'dishes.pauseReasonOptional': 'Pause reason (optional)',
  'dishes.pauseReasonPlaceholder': 'E.g.: Out of ingredients...',
  'dishes.dishPausedTemp': 'Dish paused temporarily',
  'dishes.reactivateDishNow': 'Reactivate Now',
  'dishes.willReturnAt': 'Will return at',
  'dishes.remaining': 'remaining',
  'dishes.ended': 'ended',
  'dishes.hoursCount': 'hour(s)',
  'dishes.or': 'or',
  'dishes.addOnGroup': 'Add-on Group',
  'dishes.addOnGroupName': 'Group Name',
  'dishes.addOnItem': 'Add-on Item',
  'dishes.required': 'Required',
  'dishes.optional': 'Optional',
  'dishes.minSelection': 'Min Selection',
  'dishes.maxSelection': 'Max Selection',
  'dishes.addAddOnGroup': 'Add Add-on Group',
  'dishes.addAddOnItem': 'Add Item',
  'dishes.addOnPrice': 'Add-on Price',
  'dishes.details': 'Dish Details',

  // Dish Form
  'dishForm.createTitle': 'Add New Dish',
  'dishForm.editTitle': 'Edit Dish',
  'dishForm.backToDishes': 'Back to Dishes',
  'dishForm.dishName': 'Dish Name',
  'dishForm.dishDescription': 'Dish Description',
  'dishForm.dishPrice': 'Price',
  'dishForm.dishCategory': 'Category',
  'dishForm.noCategory': 'Uncategorized',
  'dishForm.dishStatus': 'Dish Status',
  'dishForm.dishImage': 'Dish Image',
  'dishForm.uploadImage': 'Upload Image',
  'dishForm.removeImage': 'Remove Image',
  'dishForm.saveDish': 'Save Dish',
  'dishForm.createDish': 'Add Dish',
  'dishForm.updateDish': 'Update Dish',
  'dishForm.loadingData': 'Loading data...',
  'dishForm.loadFailed': 'Failed to load dish data',
  'dishForm.createSuccess': 'Dish added successfully',
  'dishForm.updateSuccess': 'Dish updated successfully',
  'dishForm.saveFailed': 'Failed to save dish',

  // Orders
  'orders.title': 'Manage Orders',
  'orders.subtitle': 'View and manage all orders',
  'orders.orderCount': 'order',
  'orders.totalOrders': 'Total Orders',
  'orders.completed': 'Completed',
  'orders.totalRevenue': 'Total Revenue',
  'orders.noOrders': 'No orders',
  'orders.newOrdersHint': 'New orders will appear here',
  'orders.connected': 'Connected',
  'orders.disconnected': 'Disconnected',
  'orders.notifications': 'Notifications',
  'orders.allTab': 'All',
  'orders.newTab': 'New',
  'orders.confirmedTab': 'Confirmed',
  'orders.preparingTab': 'Preparing',
  'orders.completedTab': 'Completed',
  'orders.cancelledTab': 'Cancelled',
  'orders.returnedTab': 'Returned',
  'orders.searchPlaceholder': 'Search by order number, customer name, or phone...',
  'orders.orderType': 'Order Type',
  'orders.delivery': 'Delivery',
  'orders.pickup': 'Pickup',
  'orders.dineIn': 'Dine In',
  'orders.loadingOrders': 'Loading orders...',
  'orders.customerName': 'Customer Name',
  'orders.customerInfo': 'Customer Information',
  'orders.date': 'Date',
  'orders.itemCount': 'Item Count',
  'orders.product': 'product',
  'orders.orderDetails': 'Order Details',
  'orders.orderNotes': 'Order Notes',
  'orders.cancelOrder': 'Cancel Order',
  'orders.total': 'Total',
  'orders.loadFailed': 'Failed to load orders',
  'orders.newOrder': 'New order!',
  'orders.orderCancelled': 'Order cancelled',
  'orders.statusUpdateSuccess': 'Order status updated successfully',
  'orders.statusUpdateFailed': 'Failed to update order status',
  'orders.updateSuccessPrintFailed': 'Order updated but print failed',
  'orders.cancelSuccess': 'Order cancelled successfully',
  'orders.cancelFailed': 'Failed to cancel order',
  'orders.dineInCustomer': 'Dine-in Customer',
  'orders.status': 'Status',
  'orders.customer': 'Customer',
  'orders.items': 'Items',
  'orders.time': 'Time',
  'orders.actions': 'Actions',
  'orders.orderNumber': 'Order Number',

  // Order Status
  'orderStatus.pending': 'Pending',
  'orderStatus.confirmed': 'Confirmed',
  'orderStatus.preparing': 'Preparing',
  'orderStatus.completed': 'Completed',
  'orderStatus.returned': 'Returned',
  'orderStatus.cancelled': 'Cancelled',

  // Table Status
  'tableStatus.available': 'Available',
  'tableStatus.occupied': 'Occupied',
  'tableStatus.reserved': 'Reserved',

  // Order Type
  'orderType.delivery': 'Delivery',
  'orderType.pickup': 'Pickup',
  'orderType.dine_in': 'Dine In',
  'orderType.takeaway': 'Takeaway',
  'orderType.cashier': 'Cashier',
  'orderType.delivery_company': 'Delivery Company',
  'cashier.deliveryCompany': 'Delivery Company',
  'cashier.selectCompany': 'Select Delivery Company',
  'cashier.externalOrderNumber': 'External Order Number',
  'cashier.enterExternalNumber': 'Enter platform order number...',
  'cashier.deliveryCompanyCheckout': 'Delivery Company Order Details',

  // Tables
  'tables.title': 'Manage Tables',
  'tables.subtitle': 'View and manage restaurant tables',
  'tables.manageDescription': 'Manage restaurant tables and QR codes',
  'tables.addTable': 'Add Table',
  'tables.addTablesHint': 'Start by adding tables to your restaurant',
  'tables.loadFailed': 'Failed to load tables',
  'tables.loading': 'Loading tables...',
  'tables.noTables': 'No tables',
  'tables.tableCount': 'table',
  'tables.totalTables': 'Total Tables',
  'tables.active': 'Active',
  'tables.inactive': 'Inactive',
  'tables.activeStatus': 'Active Status',
  'tables.statusLabel': 'Status',
  'tables.saveSuccess': 'Table saved successfully',
  'tables.seats': 'seats',
  'tables.activeOrders': 'active order',
  'tables.disabled': 'Disabled',
  'tables.available': 'Available',
  'tables.occupied': 'Occupied',
  'tables.reserved': 'Reserved',
  'tables.activeOrder': 'active order',
  'tables.statusAvailable': 'Available',
  'tables.statusOccupied': 'Occupied',
  'tables.statusReserved': 'Reserved',
  'tables.disable': 'Disable',
  'tables.enable': 'Enable',
  'tables.viewQRCode': 'View QR Code',
  'tables.editTable': 'Edit Table',
  'tables.addNewTable': 'Add New Table',
  'tables.tableNumberRequired': 'Table number is required',
  'tables.tableNumberLabel': 'Table Number',
  'tables.tableNumberPlaceholder': 'E.g.: 1, A1, VIP-5',
  'tables.locationOptional': 'Location (optional)',
  'tables.locationPlaceholder': 'E.g.: First floor, Outdoor area',
  'tables.seatsOptional': 'Number of Seats (optional)',
  'tables.seatsPlaceholder': 'E.g.: 4',
  'tables.saveError': 'Error saving table',
  'tables.saveChanges': 'Save Changes',

  // Scheduling
  'scheduling.title': 'Dish Scheduling',
  'scheduling.subtitle': 'Manage dish availability and scheduling from one place',
  'scheduling.dishCount': 'dish',
  'scheduling.menuOpen': 'Menu Open',
  'scheduling.menuClosed': 'Menu Closed',
  'scheduling.menuOpenDesc': 'Customers can view the menu and place orders',
  'scheduling.menuClosedDesc': 'Customers can view the menu only, no ordering',
  'scheduling.searchDish': 'Search for a dish...',
  'scheduling.scheduleDishes': 'Dish Scheduling',
  'scheduling.allFilter': 'Refresh',
  'scheduling.availableNow': 'Available Now',
  'scheduling.pausedFilter': 'Paused',
  'scheduling.unavailableFilter': 'Unavailable',
  'scheduling.hasSchedule': 'Has Schedule',
  'scheduling.noMatchingDishes': 'No dishes matching the search',
  'scheduling.noDishes': 'No dishes',
  'scheduling.dishCol': 'Dish',
  'scheduling.statusCol': 'Status',
  'scheduling.scheduleCol': 'Schedule',
  'scheduling.availabilityCol': 'Availability',
  'scheduling.actionsCol': 'Actions',
  'scheduling.scheduled': 'Scheduled',
  'scheduling.pauseTemp': 'Pause',
  'scheduling.schedule': 'Schedule',
  'scheduling.reactivate': 'Reactivate',
  'scheduling.pauseFor': 'Pause for:',
  'scheduling.scheduleAvailability': 'Availability Schedule',
  'scheduling.saveSchedule': 'Save Schedule',
  'scheduling.loadingDishes': 'Loading dishes...',
  'scheduling.loadFailed': 'Failed to load dishes',
  'scheduling.menuOpenSuccess': 'Order receiving is now open',
  'scheduling.menuCloseSuccess': 'Order receiving is now closed',
  'scheduling.menuToggleFailed': 'Failed to update menu status',
  'scheduling.dishActivated': 'Dish activated',
  'scheduling.dishDeactivated': 'Dish deactivated',
  'scheduling.dishToggleFailed': 'Failed to update dish status',
  'scheduling.dishPausedFor': '',
  'scheduling.dishPausedForSuffix': 'paused for',
  'scheduling.hourSuffix': 'hour(s)',
  'scheduling.dishPauseFailed': 'Failed to pause dish',
  'scheduling.dishReactivated': 'reactivated',
  'scheduling.dishReactivateFailed': 'Failed to reactivate dish',
  'scheduling.scheduleSaved': 'Availability schedule saved',
  'scheduling.scheduleSaveFailed': 'Failed to save availability schedule',
  'scheduling.pausedUntil': 'Paused',
  'scheduling.notAvailable': 'Unavailable',
  'scheduling.availableStatus': 'Available',
  'scheduling.hour1': '1 Hour',
  'scheduling.hour2': '2 Hours',
  'scheduling.hour4': '4 Hours',
  'scheduling.hour8': '8 Hours',
  'scheduling.fullDay': 'Full Day',
  'scheduling.hours': 'h',
  'scheduling.minutes': 'm',
  'scheduling.minute': 'minute',

  // Admin
  'admin.dashboard': 'Admin Dashboard',
  'admin.restaurants': 'Restaurants',
  'admin.restaurantCount': 'restaurant(s) registered',
  'admin.addRestaurant': 'Add New Restaurant',
  'admin.searchRestaurant': 'Search by restaurant name or owner...',
  'admin.loading': 'Loading...',
  'admin.noRestaurants': 'No restaurants',
  'admin.startAdding': 'Start by adding a new restaurant',
  'admin.restaurantOwner': 'Restaurant Owner',
  'admin.active': 'Active',
  'admin.inactive': 'Inactive',
  'admin.loadFailed': 'Failed to load restaurants',
  'admin.deleteFailed': 'Failed to delete restaurant',
  'admin.totalRestaurants': 'Total Restaurants',
  'admin.totalCategories': 'Total Categories',
  'admin.totalDishes': 'Total Dishes',
  'admin.totalTables': 'Tables',

  // Admin Restaurant Form
  'adminForm.createTitle': 'Add New Restaurant',
  'adminForm.createSubtitle': 'Add a new restaurant to the system',
  'adminForm.editTitle': 'Edit Restaurant',
  'adminForm.editSubtitle': 'Edit restaurant details',
  'adminForm.backToRestaurants': 'Back to Restaurants',
  'adminForm.whatsappNotifications': 'WhatsApp Notifications',
  'adminForm.whatsappNotificationsDesc': 'Receive new order notifications via WhatsApp',
  'adminForm.whatsappNumber': 'WhatsApp Number',
  'adminForm.whatsappNumberHint': 'Phone number to receive notifications',
  'adminForm.tableOrderingEnabled': 'Table ordering enabled',
  'adminForm.tableOrderingDisabled': 'Table ordering disabled',
  'adminForm.tableOrderingHint': 'Control whether customers can order after scanning the table QR code (view-only or with ordering)',
  'adminForm.whatsappEnabled': 'WhatsApp notifications enabled',
  'adminForm.whatsappDisabled': 'WhatsApp notifications disabled',

  // Home Page
  'home.heroTitle': 'Smart Digital Menu for Your Restaurant',
  'home.heroSubtitle': 'Create a professional digital menu with QR code and start receiving orders online',
  'home.startNow': 'Start Now',
  'home.watchDemo': 'Watch Demo',
  'home.servicesTitle': 'Our Services',
  'home.aboutTitle': 'About Us',
  'home.partnersTitle': 'Our Partners',
  'home.feature1Title': 'Digital Food Menus',
  'home.feature1Desc': 'Interactive menus easy to browse with high-quality images of your dishes',
  'home.feature2Title': 'Smart Management',
  'home.feature2Desc': 'Comprehensive dashboard to manage restaurant and orders easily',
  'home.feature3Title': 'Increase Sales',
  'home.feature3Desc': 'Marketing tools and analytics to boost your revenue',

  // Menu Page (Public)
  'menu.loading': 'Loading menu...',
  'menu.notFound': 'Menu not found',
  'menu.searchDish': 'Search for a dish...',
  'menu.allCategories': 'All',
  'menu.addToCart': 'Add to Cart',
  'menu.outOfStock': 'Out of Stock',
  'menu.menuClosed': 'Menu is currently closed',
  'menu.restaurantNotAccepting': 'Menu is Currently Closed',
  'menu.menuClosedMessage': 'Sorry, the restaurant is not accepting orders at this time. Please try again later.',
  'menu.notAcceptingOrders': 'Restaurant is not accepting orders currently',
  'menu.tableOrderingDisabled': 'Table ordering is not enabled for this restaurant, you can only browse the menu',
  'menu.dishUnavailable': 'This dish is currently unavailable',
  'menu.browseMenu': 'Browse Menu Only',
  'menu.dishAdded': 'Added to cart',
  'menu.addError': 'Failed to add dish to cart',
  'menu.updateError': 'Failed to update quantity',
  'menu.dishRemoved': 'Dish removed from cart',
  'menu.sorry': 'Sorry!',
  'menu.tableNumber': 'Table',

  // Cart
  'cart.title': 'Shopping Cart',
  'cart.empty': 'Cart is empty',
  'cart.emptyHint': 'Add some delicious dishes to your cart',
  'cart.total': 'Total',
  'cart.checkout': 'Checkout',
  'cart.continueShopping': 'Continue Shopping',
  'cart.removeItem': 'Remove',
  'cart.clearCart': 'Clear Cart',
  'cart.addFailed': 'Failed to add item to cart',
  'cart.updateFailed': 'Failed to update item',
  'cart.removeFailed': 'Failed to remove item',
  'cart.clearFailed': 'Failed to clear cart',
  'cart.loading': 'Loading cart...',
  'cart.canKeepCart': 'You can keep your cart and order later',

  // Checkout
  'checkout.title': 'Checkout',
  'checkout.customerName': 'Name',
  'checkout.phone': 'Phone Number',
  'checkout.address': 'Address',
  'checkout.notes': 'Notes',
  'checkout.orderType': 'Order Type',
  'checkout.placeOrder': 'Place Order',
  'checkout.orderSummary': 'Order Summary',
  'checkout.subtotal': 'Subtotal',
  'checkout.deliveryFee': 'Delivery Fee',
  'checkout.grandTotal': 'Total',
  'checkout.quantity': 'Quantity',
  'checkout.creatingOrder': 'Creating order...',
  'checkout.orderConfirmationNote': 'Order details will be sent via phone',
  'checkout.loading': 'Loading order details...',
  'checkout.dineIn': 'Dine In',
  'checkout.tableNumber': 'Table',

  // Order Success
  'orderSuccess.title': 'Your order has been placed successfully!',
  'orderSuccess.thankYou': 'Thank you for your order!',
  'orderSuccess.orderNumber': 'Order Number',
  'orderSuccess.trackOrder': 'Track Order',
  'orderSuccess.backToMenu': 'Back to Menu',
  'orderSuccess.backToHome': 'Back to Home',
  'orderSuccess.noData': 'No order data available',

  // Track Order
  'trackOrder.title': 'Track Order',
  'trackOrder.subtitle': 'Enter your phone number to track your order',
  'trackOrder.orderStatus': 'Order Status',
  'trackOrder.orderDetails': 'Order Details',
  'trackOrder.enterRequired': 'Please enter your phone number',
  'trackOrder.notFound': 'No orders found',

  // Notifications
  'notifications.settings': 'Notification Settings',
  'notifications.enableSound': 'Enable Sound',
  'notifications.volume': 'Volume',
  'notifications.testSound': 'Test Sound',
  'notifications.playing': 'Playing...',
  'notifications.repeatCount': 'Repeat Count',
  'notifications.once': 'Once',
  'notifications.fiveTimes': '5 Times',
  'notifications.reset': 'Reset',
  'notifications.alertInfo': 'You will hear an alert sound when a new order arrives',

  // WhatsApp
  'whatsapp.support': 'Contact us via WhatsApp',

  // Protected Route
  'protected.unauthorized': 'Unauthorized Access',
  'protected.loginRequired': 'Please log in to access this page',

  // Loading
  'loading.text': 'Loading...',

  // Profile Components
  'profileComp.logo': 'Restaurant Logo',
  'profileComp.background': 'Cover Image',
  'profileComp.basicInfo': 'Basic Information',
  'profileComp.contactInfo': 'Contact Information',
  'profileComp.socialLinks': 'Social Media Links',
  'profileComp.menuSettings': 'Menu Settings',
  'profileComp.restaurantName': 'Restaurant Name',
  'profileComp.restaurantDesc': 'Restaurant Description',
  'profileComp.phone': 'Phone Number',
  'profileComp.primaryPhone': 'Primary Number',
  'profileComp.additionalPhone': 'Additional Number',
  'profileComp.addPhone': 'Add Phone Number',
  'profileComp.removePhone': 'Remove Number',
  'profileComp.workingHours': 'Working Hours',
  'profileComp.address': 'Address',
  'profileComp.mapUrl': 'Map Link',
  'profileComp.timezone': 'Timezone',
  'profileComp.facebook': 'Facebook',
  'profileComp.instagram': 'Instagram',
  'profileComp.twitter': 'Twitter',
  'profileComp.uploadLogo': 'Upload Logo',
  'profileComp.removeLogo': 'Remove Logo',
  'profileComp.uploadBackground': 'Upload Cover Image',
  'profileComp.removeBackground': 'Remove Cover Image',
  'profileComp.dragOrClick': 'Drag image here or click to select',
  'profileComp.saveChanges': 'Save Changes',
  'profileComp.saving': 'Saving...',
  'profileComp.isMenuPublic': 'Is menu public?',

  // Restaurant components
  'restaurant.recentOrders': 'Recent Orders',
  'restaurant.topDishes': 'Most Ordered Dishes',
  'restaurant.revenueChart': 'Revenue Chart',
  'restaurant.ordersSummary': 'Orders Summary',
  'restaurant.preparingOrders': 'Preparing Orders',
  'restaurant.completedOrders': 'Completed Orders',
  'restaurant.noRecentOrders': 'No recent orders',
  'restaurant.viewAllOrders': 'View All Orders',
  'restaurant.quickActions': 'Quick Actions',
  'restaurant.restaurantInfo': 'Restaurant Info',
  'restaurant.welcomeMessage': 'Welcome to the Dashboard',
  'restaurant.todayStats': 'Today\'s Statistics',
  'restaurant.viewDetails': 'View Details',
  'restaurant.manageOrders': 'Manage Orders',
  'restaurant.manageTables': 'Manage Tables',
  'restaurant.manageMenu': 'Manage Menu',

  // Admin form
  'adminForm.restaurantName': 'Restaurant Name',
  'adminForm.ownerName': 'Owner Name',
  'adminForm.ownerEmail': 'Owner Email',
  'adminForm.ownerPassword': 'Owner Password',
  'adminForm.restaurantSlug': 'URL Slug',
  'adminForm.isActive': 'Active',
  'adminForm.createRestaurant': 'Create Restaurant',
  'adminForm.updateRestaurant': 'Update Restaurant',
  'adminForm.requiredField': 'This field is required',
  'adminForm.saving': 'Saving...',
  'adminForm.cancel': 'Cancel',

  // Additional keys
  'cart.itemsInCart': 'Item in Cart',
  'cart.browseRestaurants': 'Back to Menu',
  'cart.noItemsYet': 'You have not added any dishes yet',
  'cart.dish': 'Dish',
  'cart.free': 'Free',
  'cart.addOns': 'Add-ons',
  'cart.freePerDish': 'free per dish',
  'cart.maxLimit': 'Max',
  'cart.orderSummary': 'Order Summary',
  'cart.reviewOrder': 'Review your order',
  'cart.subtotal': 'Subtotal',
  'cart.serviceFee': 'Service Fee',
  'cart.deliveryFees': 'Delivery Fees',
  'cart.determinedLater': 'Determined later',
  'cart.restaurantNotAccepting': 'Restaurant is not accepting orders currently',
  'cart.tryLater': 'Please try later',
  'cart.termsAgree': 'By clicking "Place Order" you agree to the terms of service',

  // Hook Messages
  'hooks.fillRequiredFields': 'Please fill all required fields',
  'hooks.enterDeliveryAddress': 'Please enter delivery address',
  'hooks.createOrderFailed': 'Failed to create order',
  'hooks.loadStatsFailed': 'Failed to load statistics',
  'hooks.loginFailed': 'Login failed. Please check your credentials',
  'hooks.loadTablesFailed': 'Failed to load tables',
  'hooks.tableDeleteSuccess': 'Table deleted successfully',
  'hooks.tableDeleteFailed': 'Failed to delete table',
  'hooks.tableStatusUpdateSuccess': 'Table status updated successfully',
  'hooks.tableStatusUpdateFailed': 'Failed to update table status',
  'hooks.tableEnabled': 'Table enabled successfully',
  'hooks.tableDisabled': 'Table disabled successfully',
  'hooks.loadDishFailed': 'Failed to load dish data',
  'hooks.fileSizeError': 'File size must be less than 5MB',
  'hooks.fileTypeError': 'File type not supported. Please use JPG, PNG, or WEBP',
  'hooks.dishUpdateSuccess': 'Dish updated successfully',
  'hooks.dishCreateSuccess': 'Dish added successfully',
  'hooks.dishSaveFailed': 'Failed to save dish',
  'hooks.dishPauseSuccess': 'Dish paused temporarily',
  'hooks.dishPauseFailed': 'Failed to pause dish',
  'hooks.dishReactivateSuccess': 'Dish reactivated',
  'hooks.dishReactivateFailed': 'Failed to reactivate dish',
  'hooks.loadRestaurantFailed': 'Failed to load restaurant data',
  'hooks.profileUpdateSuccess': 'Profile updated successfully',
  'hooks.profileUpdateFailed': 'Failed to update profile',
  'hooks.loadDishesFailed': 'Failed to load dishes',
  'hooks.dishDeleteSuccess': 'Dish deleted successfully',
  'hooks.dishDeleteFailed': 'Failed to delete dish',
  'hooks.statusUpdateFailed': 'Failed to update status',
  'hooks.noCategory': 'No Category',
  'hooks.dishOrderUpdateSuccess': 'Dish order updated successfully',
  'hooks.dishOrderUpdateFailed': 'Failed to update order',
  'hooks.sseConnectionFailed': 'Failed to connect to notification server',
  'hooks.loadRestaurantsFailed': 'Failed to load restaurants',
  'hooks.restaurantDeleteFailed': 'Failed to delete restaurant',
  'hooks.loadDashboardFailed': 'Failed to load dashboard data',
  'hooks.restaurantLoadFailed': 'Failed to load restaurant data',
  'hooks.restaurantUpdateSuccess': 'Restaurant updated successfully',
  'hooks.restaurantCreateSuccess': 'Restaurant created successfully',
  'hooks.restaurantSaveFailed': 'Failed to save restaurant',
  'hooks.loadCategoriesFailed': 'Failed to load categories',
  'hooks.categoryCreateSuccess': 'Category added successfully',
  'hooks.categoryCreateFailed': 'Failed to add category',
  'hooks.categoryUpdateSuccess': 'Category updated successfully',
  'hooks.categoryUpdateFailed': 'Failed to update category',
  'hooks.categoryDeleteSuccess': 'Category deleted successfully',
  'hooks.categoryDeleteFailed': 'Failed to delete category',
  'hooks.categoryOrderUpdateSuccess': 'Category order updated successfully',

  // Inventory (Materials)
  'inventory.title': 'Inventory Management',
  'inventory.subtitle': 'Manage raw materials and ingredients',
  'inventory.addMaterial': 'Add Material',
  'inventory.editMaterial': 'Edit Material',
  'inventory.materialName': 'Material Name',
  'inventory.quantity': 'Quantity',
  'inventory.price': 'Total Price',
  'inventory.unitType': 'Unit Type',
  'inventory.lowStockThreshold': 'Alert Threshold',
  'inventory.lowStockThresholdHint': 'You will be alerted when quantity falls below this threshold',
  'inventory.restock': 'Restock',
  'inventory.restockMaterial': 'Restock Material',
  'inventory.adjustStock': 'Adjust Stock',
  'inventory.newQuantity': 'New Quantity',
  'inventory.addQuantity': 'Quantity to Add',
  'inventory.notes': 'Notes',
  'inventory.notesPlaceholder': 'E.g.: Purchased new materials',
  'inventory.totalMaterials': 'Total Materials',
  'inventory.inStock': 'In Stock',
  'inventory.lowStock': 'Low Stock',
  'inventory.outOfStock': 'Out of Stock',
  'inventory.noMaterials': 'No raw materials',
  'inventory.startAdding': 'Start by adding raw materials used in preparation',
  'inventory.deleteMaterial': 'Delete Material',
  'inventory.deleteConfirm': 'Are you sure you want to delete the material',
  'inventory.usedInTemplates': 'Cannot delete material because it is used in recipe templates',
  'inventory.movements': 'Movement History',
  'inventory.movementHistory': 'Stock Movement History',
  'inventory.unlimited': 'Unlimited',
  'inventory.searchPlaceholder': 'Search for a material...',
  'inventory.statusFilter': 'Stock Status',
  'inventory.all': 'All',
  'inventory.createSuccess': 'Material added successfully',
  'inventory.updateSuccess': 'Material updated successfully',
  'inventory.deleteSuccess': 'Material deleted successfully',
  'inventory.restockSuccess': 'Stock replenished successfully',
  'inventory.purchasePrice': 'Total Purchase Price',
  'inventory.purchasePriceHint': 'Total amount paid for the added quantity',
  'inventory.pricePerUnit': 'Unit Price',
  'inventory.totalPriceHint': 'Total amount for the quantity (unit price will be calculated automatically)',
  'inventory.totalValue': 'Total',
  'inventory.adjustSuccess': 'Stock adjusted successfully',
  'inventory.viewMovements': 'View Stock Movements',
  'inventory.movementType': 'Movement Type',
  'inventory.movementQty': 'Quantity',
  'inventory.movementDate': 'Date & Time',
  'inventory.movementNotes': 'Notes',
  'inventory.movementStock': 'Stock',
  'inventory.movementCost': 'Cost',
  'inventory.noMovements': 'No stock movements recorded',
  'inventory.noMovementsHint': 'Stock movements will appear here when purchases or usage occur',
  'inventory.loadingMovements': 'Loading movement history...',
  'inventory.stockBefore': 'Before',
  'inventory.stockAfter': 'After',
  'inventory.loadMore': 'Load More',
  'inventory.category': 'Category',
  'inventory.categoryFilter': 'Material Category',
  'inventory.noCategory': 'No Category',
  'inventory.categoryVegetables': 'Vegetables',
  'inventory.categoryFruits': 'Fruits',
  'inventory.categoryMeats': 'Meats',
  'inventory.categoryPoultry': 'Poultry',
  'inventory.categoryDairy': 'Dairy & Eggs',
  'inventory.categoryGrains': 'Grains & Starches',
  'inventory.categoryLegumes': 'Legumes',
  'inventory.categorySpices': 'Spices & Seasonings',
  'inventory.categoryOilsFats': 'Oils & Fats',
  'inventory.categoryBeverages': 'Beverages',
  'inventory.categoryOther': 'Other',
  'inventory.manageCategories': 'Manage Categories',
  'inventory.addCategory': 'Add Category',
  'inventory.categoryCount': 'category',
  'inventory.newCategoryPlaceholder': 'New category name...',
  'inventory.noCategories': 'No categories',
  'inventory.materialCount': 'material(s)',
  'inventory.categoryCreateSuccess': 'Category added successfully',
  'inventory.categoryCreateFailed': 'Failed to add category',
  'inventory.categoryRenameSuccess': 'Category renamed successfully',
  'inventory.categoryRenameFailed': 'Failed to rename category',
  'inventory.categoryDeleteSuccess': 'Category and all its materials deleted successfully',
  'inventory.categoryDeleteFailed': 'Failed to delete category',
  'inventory.deleteCategoryConfirm': 'Are you sure you want to delete this category?',
  'inventory.deleteCategoryWarning': 'All materials in this category will be deleted. This action cannot be undone.',

  // Units
  'units.kg': 'Kilogram',
  'units.g': 'Gram',
  'units.liter': 'Liter',
  'units.ml': 'Milliliter',
  'units.piece': 'Piece',
  'units.kgShort': 'kg',
  'units.gShort': 'g',
  'units.literShort': 'L',
  'units.mlShort': 'ml',
  'units.pieceShort': 'pc',

  // Stock Movement Types
  'movement.order_deduction': 'Order Deduction',
  'movement.order_restore': 'Order Restore',
  'movement.manual_restock': 'Manual Restock',
  'movement.manual_adjustment': 'Manual Adjustment',
  'movement.unreconciled_deficit': 'Unreconciled Deficit',

  // Templates (Recipe Templates)
  'templates.title': 'Recipe Templates',
  'templates.subtitle': 'Create and manage dish recipes',
  'templates.addTemplate': 'Add Template',
  'templates.editTemplate': 'Edit Template',
  'templates.templateName': 'Template Name',
  'templates.templateDescription': 'Template Description',
  'templates.ingredients': 'Ingredients',
  'templates.addIngredient': 'Add Ingredient',
  'templates.selectMaterial': 'Select Material',
  'templates.ingredientQuantity': 'Quantity',
  'templates.ingredientUnit': 'Unit',
  'templates.noTemplates': 'No recipe templates',
  'templates.startAdding': 'Start by creating templates for your dish recipes',
  'templates.deleteTemplate': 'Delete Template',
  'templates.deleteConfirm': 'Are you sure you want to delete the template',
  'templates.linkedDishes': 'Linked Dishes',
  'templates.cost': 'Ingredient Cost',
  'templates.availability': 'Ingredient Availability',
  'templates.available': 'Available',
  'templates.notAvailable': 'Unavailable',
  'templates.ingredientsCount': 'ingredient(s)',
  'templates.costPerServing': 'Cost per Serving',
  'templates.searchPlaceholder': 'Search for a template...',
  'templates.createSuccess': 'Template created successfully',
  'templates.updateSuccess': 'Template updated successfully',
  'templates.deleteSuccess': 'Template deleted successfully',
  'templates.selectTemplate': 'Select Recipe Template',
  'templates.noTemplate': 'No Template',
  'templates.templateLinked': 'Recipe Template',

  // Settings Page
  'settings.title': 'Settings',
  'settings.subtitle': 'Manage restaurant and system settings',
  'settings.section.profile': 'Restaurant Profile',
  'settings.section.profileDesc': 'Edit restaurant info and images',
  'settings.section.menu': 'Menu Settings',
  'settings.section.menuDesc': 'Control menu link and visibility',
  'settings.section.notifications': 'Notifications',
  'settings.section.notificationsDesc': 'Alert and notification settings',
  'settings.section.about': 'About System',
  'settings.section.aboutDesc': 'System info and support',
  'settings.comingSoon': 'Coming Soon',
  'settings.comingSoonDesc': 'This section is under development and will be available soon',
  'settings.aboutVersion': 'Version',
  'settings.aboutSupport': 'Support',
  'settings.aboutSupportDesc': 'For help and support contact us',

  // Offline / Sync
  'offline.banner.noConnection': 'No internet connection',
  'offline.banner.workingLocally': 'Working locally',
  'offline.banner.pendingOps': '{{count}} operations pending sync',
  'offline.banner.syncing': 'Syncing…',
  'offline.banner.syncComplete': 'Sync completed successfully',
  'offline.banner.syncFailed': '{{count}} operations failed',
  'offline.banner.retry': 'Retry',
  'offline.badge.pendingSync': 'Pending sync',
  'offline.badge.cachedData': 'Cached data',
  'offline.order.tempNumber': 'Temporary number',
  'offline.order.willSyncLater': 'Will sync when connection returns',
  'offline.order.synced': 'Synced — Order #{{orderNumber}}',
  'offline.order.createdOffline': 'Order created locally — will sync when connection returns',
  'offline.staff.syncRequired': 'Staff member cannot log in until synced',
  'offline.menu.cachedView': 'Showing menu from last visit',
  'offline.file.pendingUpload': 'Image will be uploaded when connection returns',
  'offline.sync.processing': 'Processing {{count}} operations…',
  'offline.sync.completed': '{{count}} operations synced successfully',
  'offline.sync.partialFail': '{{failed}} of {{total}} operations failed',
  'offline.sync.conflict': '{{entity}} was already updated by another user',
  'nav.notifications': 'Notifications & Alerts',
  'inventory.needsReconciliation': 'Inventory reconciliation (unrecorded restock)',

  // Onboarding & Learning Center
  'onboarding.welcome.title': 'Welcome to Your Restaurant System',
  'onboarding.welcome.description': 'This interactive tour will guide you through the complete setup of your restaurant. Learn how to configure your menu, manage staff, control inventory, and track your daily profits.',
  'onboarding.settings.title': '1. Basic Configuration',
  'onboarding.settings.description': 'Start by visiting the Settings page. Here you can set your restaurant logo, operating hours, and configure your delivery zones. Delivery zones use GPS to ensure customers can only order if they are within your covered areas.',
  'onboarding.staff.title': '2. Staff & Roles',
  'onboarding.staff.description': 'Never share your Owner account! Go to the Staff page to create individual accounts for Cashiers, Waiters, Accountants, and Inventory Managers. Each role only sees what they need to do their job.',
  'onboarding.menu.title': '3. Menu & Pricing Rule',
  'onboarding.menu.description': 'Create Categories and then add your Dishes. IMPORTANT: All prices use the "x1000" rule. If a meal costs 15,000 IQD, you simply enter "15". You can also add modifiers (like Extra Cheese) with their own prices and free quantities.',
  'onboarding.inventory.title': '4. Inventory & Recipes',
  'onboarding.inventory.description': 'To make the system automatically deduct stock when you sell a meal, you must create Raw Materials (Inventory) and then link them to a Dish using "Preparation Templates". This also calculates your exact food costs (COGS).',
  'onboarding.delivery.title': '5. Delivery Companies',
  'onboarding.delivery.description': 'If you use external apps like Talabat or Toters, add them in the Delivery Companies section. The system will automatically calculate their commissions and discounts so your net profit is always accurate.',
  'onboarding.pos.title': '6. Cash Register & POS',
  'onboarding.pos.description': 'Cashiers CANNOT take orders until a manager opens their "Cash Register" shift. Orders move from Pending → Confirmed → Completed. When the internet drops, the system continues to work Offline and syncs automatically later.',
  'onboarding.reports.title': '7. Reports & End of Day',
  'onboarding.reports.description': 'At night, close the cash registers to see if there are any cash shortages. Record your daily Expenses, and check the Profit & Loss report to see your exact net profit margin for the day. You are now ready to operate!',
  // --- ONBOARDING TOUR ---
  'onboarding.next': 'Next',
  'onboarding.back': 'Back',
  'onboarding.skip': 'Skip tour',
  'onboarding.finish': 'Finish Tour',

  // Owner
  'onboarding.owner.welcome.title': 'Welcome to Restaurant Menu',
  'onboarding.owner.welcome.description': 'As the owner, you have full control over the restaurant. Let\'s take a quick tour of your dashboard and features.',
  'onboarding.owner.settings.title': 'Settings',
  'onboarding.owner.settings.description': 'Configure your restaurant details, logo, receipt printing, and delivery zones here.',
  'onboarding.owner.staff.title': 'Staff Management',
  'onboarding.owner.staff.description': 'Add employees and assign them roles (Cashier, Accountant, etc.).',
  'onboarding.owner.menu.title': 'Menu & Categories',
  'onboarding.owner.menu.description': 'Create your categories and dishes. Remember the x1000 pricing rule!',
  'onboarding.owner.inventory.title': 'Inventory',
  'onboarding.owner.inventory.description': 'Manage raw materials and track stock levels.',
  'onboarding.owner.delivery.title': 'Delivery Companies',
  'onboarding.owner.delivery.description': 'Add 3rd party delivery apps to track their commissions accurately.',
  'onboarding.owner.pos.title': 'Point of Sale',
  'onboarding.owner.pos.description': 'The main interface for your cashiers to take orders.',
  'onboarding.owner.reports.title': 'Reports',
  'onboarding.owner.reports.description': 'View your Profit & Loss, sales analytics, and end-of-day reports.',
  'onboarding.owner.complete.title': 'Tour Complete!',
  'onboarding.owner.complete.description': 'You are ready to manage your restaurant. Visit the Learning Center anytime for detailed guides.',

  // Cashier
  'onboarding.cashier.welcome.title': 'Welcome Cashier',
  'onboarding.cashier.welcome.description': 'Let\'s take a quick tour of the Point of Sale and your daily tools.',
  'onboarding.cashier.pos.title': 'Point of Sale',
  'onboarding.cashier.pos.description': 'Take dine-in and delivery orders here.',
  'onboarding.cashier.orders.title': 'Orders',
  'onboarding.cashier.orders.description': 'Manage active orders and confirm requests from waiters.',
  'onboarding.cashier.tables.title': 'Tables',
  'onboarding.cashier.tables.description': 'View table status and assign orders to tables.',
  'onboarding.cashier.scheduling.title': 'Scheduling',
  'onboarding.cashier.scheduling.description': 'Pause dishes temporarily if they run out during your shift.',
  'onboarding.cashier.inventory.title': 'Inventory',
  'onboarding.cashier.inventory.description': 'Check stock levels for raw materials.',
  'onboarding.cashier.complete.title': 'Ready to go!',
  'onboarding.cashier.complete.description': 'You are ready to take orders. Check the Learning Center if you need help.',

  // Accountant
  'onboarding.accountant.welcome.title': 'Welcome Accountant',
  'onboarding.accountant.welcome.description': 'Here are your tools for financial management.',
  'onboarding.accountant.dashboard.title': 'Dashboard',
  'onboarding.accountant.dashboard.description': 'Overview of today\'s financial metrics.',
  'onboarding.accountant.expenses.title': 'Expenses',
  'onboarding.accountant.expenses.description': 'Record daily expenses for accurate P&L calculation.',
  'onboarding.accountant.cashRegister.title': 'Cash Register',
  'onboarding.accountant.cashRegister.description': 'Open shifts for cashiers and reconcile cash at the end of the day.',
  'onboarding.accountant.reports.title': 'Reports',
  'onboarding.accountant.reports.description': 'Generate Profit & Loss and sales reports.',
  'onboarding.accountant.deliveryCompanies.title': 'Delivery Companies',
  'onboarding.accountant.deliveryCompanies.description': 'Manage external delivery commissions.',
  'onboarding.accountant.inventory.title': 'Inventory',
  'onboarding.accountant.inventory.description': 'Monitor inventory values and costs.',
  'onboarding.accountant.complete.title': 'Setup Complete',
  'onboarding.accountant.complete.description': 'You are ready to manage finances.',

  // Inventory Manager
  'onboarding.inventoryManager.welcome.title': 'Welcome Inventory Manager',
  'onboarding.inventoryManager.welcome.description': 'Your tools for stock and recipes.',
  'onboarding.inventoryManager.inventory.title': 'Inventory',
  'onboarding.inventoryManager.inventory.description': 'Add raw materials and update stock quantities.',
  'onboarding.inventoryManager.templates.title': 'Preparation Templates',
  'onboarding.inventoryManager.templates.description': 'Link raw materials to dishes so stock deducts automatically.',
  'onboarding.inventoryManager.notifications.title': 'Notifications',
  'onboarding.inventoryManager.notifications.description': 'Check here for low stock warnings and negative stock anomalies.',
  'onboarding.inventoryManager.complete.title': 'Ready!',
  'onboarding.inventoryManager.complete.description': 'You are all set to manage inventory.',

  // Delivery Cashier
  'onboarding.deliveryCashier.welcome.title': 'Welcome Delivery Cashier',
  'onboarding.deliveryCashier.welcome.description': 'Your streamlined POS for external delivery apps.',
  'onboarding.deliveryCashier.pos.title': 'POS',
  'onboarding.deliveryCashier.pos.description': 'Enter orders from Talabat, Toters, etc.',
  'onboarding.deliveryCashier.deliveryOrders.title': 'Delivery Orders',
  'onboarding.deliveryCashier.deliveryOrders.description': 'Track and manage delivery dispatching.',
  'onboarding.deliveryCashier.complete.title': 'Ready!',
  'onboarding.deliveryCashier.complete.description': 'You are ready to process delivery orders.',

  // --- LEARNING CENTER ---
  'learning.title': 'Learning Center',
  'learning.subtitle': 'Role-specific guides, tutorials, and operational handbook.',
  'learning.restartTour': 'Restart Interactive Tour',
  'learning.roleName.owner': 'Restaurant Owner',
  'learning.roleName.cashier': 'Cashier',
  'learning.roleName.accountant': 'Accountant',
  'learning.roleName.inventoryManager': 'Inventory Manager',
  'learning.roleName.deliveryCashier': 'Delivery Cashier',

  // Owner Content
  'learning.owner.gettingStarted.title': 'Getting Started',
  'learning.owner.gettingStarted.purpose.title': 'Your Role',
  'learning.owner.gettingStarted.purpose.content': 'As the owner, you have full control over the system. You can configure settings, manage staff, and analyze financial performance.',
  'learning.owner.gettingStarted.firstSetup.title': 'First-Time Setup',
  'learning.owner.gettingStarted.firstSetup.step1': '1. Configure Settings (Logo, receipt printer, delivery zones).',
  'learning.owner.gettingStarted.firstSetup.step2': '2. Add Categories and Dishes to your Menu.',
  'learning.owner.gettingStarted.firstSetup.step3': '3. Create staff accounts and assign roles.',
  'learning.owner.gettingStarted.firstSetup.step4': '4. Add Raw Materials in Inventory.',
  'learning.owner.gettingStarted.firstSetup.step5': '5. Link materials to dishes using Preparation Templates.',

  'learning.owner.dashboard.title': 'Dashboard Overview',
  'learning.owner.dashboard.overview.title': 'Key Metrics',
  'learning.owner.dashboard.overview.content': 'The dashboard gives you a real-time snapshot of today\'s sales, active orders, and low-stock alerts.',
  'learning.owner.dashboard.stats.title': 'Charts',
  'learning.owner.dashboard.stats.content': 'Visual charts help you identify peak hours and top-selling items.',

  'learning.owner.navigation.title': 'Navigation Guide',
  'learning.owner.navigation.sidebar.title': 'Sidebar',
  'learning.owner.navigation.sidebar.content': 'Use the left sidebar to navigate. On mobile, tap the hamburger menu icon to open it.',

  'learning.owner.dailyWorkflow.title': 'Daily Workflow',
  'learning.owner.dailyWorkflow.morning.title': 'Morning',
  'learning.owner.dailyWorkflow.morning.content': 'Check notifications for low stock. Ensure cash registers are opened for your cashiers (or have your accountant do it).',
  'learning.owner.dailyWorkflow.during.title': 'During Shift',
  'learning.owner.dailyWorkflow.during.content': 'Monitor live orders. Use the Scheduling page to pause dishes if ingredients run out.',
  'learning.owner.dailyWorkflow.closing.title': 'Closing',
  'learning.owner.dailyWorkflow.closing.content': 'Ensure all registers are closed. Check the Profit & Loss report for the day\'s performance.',

  'learning.owner.features.title': 'Feature Tutorials',
  'learning.owner.features.settings.title': 'Settings',
  'learning.owner.features.settings.content': 'Manage restaurant profile, printing preferences, and tax rates.',
  'learning.owner.features.staff.title': 'Staff',
  'learning.owner.features.staff.content': 'Add employees. Each role has specific permissions. Waiters can only take orders.',
  'learning.owner.features.menu.title': 'Menu',
  'learning.owner.features.menu.content': 'Organize dishes into categories. Add modifiers (like sizes or extra toppings).',
  'learning.owner.features.inventory.title': 'Inventory',
  'learning.owner.features.inventory.content': 'Track raw materials. Stock deducts automatically when meals are sold (if templates are configured).',
  'learning.owner.features.pos.title': 'POS',
  'learning.owner.features.pos.content': 'The Point of Sale is where cashiers process dine-in and delivery orders.',
  'learning.owner.features.tables.title': 'Tables',
  'learning.owner.features.tables.content': 'Manage dine-in table layout and status.',
  'learning.owner.features.delivery.title': 'Delivery Companies',
  'learning.owner.features.delivery.content': 'Add apps like Talabat. The system calculates their commission to show your true net profit.',
  'learning.owner.features.reports.title': 'Reports',
  'learning.owner.features.reports.content': 'Detailed analytics including Profit & Loss, End of Day, and Sales by Item.',
  'learning.owner.features.expenses.title': 'Expenses',
  'learning.owner.features.expenses.content': 'Log daily costs (rent, utilities, groceries) to calculate accurate net profit.',
  'learning.owner.features.scheduling.title': 'Scheduling',
  'learning.owner.features.scheduling.content': 'Quickly enable/disable dishes without deleting them from the menu.',

  'learning.owner.commonTasks.title': 'Common Tasks',
  'learning.owner.commonTasks.addDish.title': 'Adding a Dish',
  'learning.owner.commonTasks.addDish.content': 'Go to Menu > Select Category > Add Dish. Enter the price (e.g. 15 for 15,000).',
  'learning.owner.commonTasks.addStaff.title': 'Adding Staff',
  'learning.owner.commonTasks.addStaff.content': 'Go to Staff > Add Employee. Provide a username. The system appends your restaurant ID.',
  'learning.owner.commonTasks.openRegister.title': 'Opening a Register',
  'learning.owner.commonTasks.openRegister.content': 'Go to Cash Register > Open Shift. Enter the starting cash amount.',

  'learning.owner.advanced.title': 'Advanced Features',
  'learning.owner.advanced.pricing.title': 'x1000 Pricing Rule',
  'learning.owner.advanced.pricing.content': 'To simplify data entry, all prices are multiplied by 1000. Enter 5 for 5,000 IQD.',
  'learning.owner.advanced.templates.title': 'Preparation Templates',
  'learning.owner.advanced.templates.content': 'Link multiple raw ingredients to a single dish to automate stock deduction.',
  'learning.owner.advanced.deliveryZones.title': 'Delivery Zones',
  'learning.owner.advanced.deliveryZones.content': 'Set up zones in Settings to automatically calculate delivery fees in the POS.',

  'learning.owner.tips.title': 'Tips & Best Practices',
  'learning.owner.tips.best.title': 'Best Practices',
  'learning.owner.tips.best.content': 'Always log expenses daily. Reconcile cash registers at the exact end of every shift.',
  'learning.owner.tips.mistakes.title': 'Common Mistakes',
  'learning.owner.tips.mistakes.content': 'Forgetting to link raw materials to dishes. This prevents auto-deduction of stock.',

  'learning.owner.faq.title': 'FAQ',
  'learning.owner.faq.q1.title': 'Why can\'t my cashier make orders?',
  'learning.owner.faq.q1.content': 'They need an open Cash Register shift. Open one for them in the Cash Register page.',
  'learning.owner.faq.q2.title': 'How does offline mode work?',
  'learning.owner.faq.q2.content': 'If internet drops, cashiers can still take orders. The system syncs automatically when reconnected.',
  'learning.owner.faq.q3.title': 'Can waiters delete orders?',
  'learning.owner.faq.q3.content': 'No, waiters can only submit pending orders. Cashiers must confirm or cancel them.',

  'learning.owner.troubleshooting.title': 'Troubleshooting',
  'learning.owner.troubleshooting.offline.title': 'Offline Sync Issues',
  'learning.owner.troubleshooting.offline.content': 'If the offline banner says "Pending Sync", keep the app open until internet is restored.',
  'learning.owner.troubleshooting.print.title': 'Printer Issues',
  'learning.owner.troubleshooting.print.content': 'Ensure the Print Server utility is running on the Windows computer connected to your printers.',

  'learning.owner.whatsNew.title': 'What\'s New',
  'learning.owner.whatsNew.latest.title': 'Latest Updates',
  'learning.owner.whatsNew.latest.content': 'Role-based learning center and interactive onboarding tours added.',

  // Cashier Content
  'learning.cashier.gettingStarted.title': 'Getting Started',
  'learning.cashier.gettingStarted.purpose.title': 'Your Role',
  'learning.cashier.gettingStarted.purpose.content': 'You manage the Point of Sale, process payments, and confirm orders sent by waiters.',
  'learning.cashier.gettingStarted.firstLogin.title': 'First Login',
  'learning.cashier.gettingStarted.firstLogin.content': 'Familiarize yourself with the POS layout. Note: You cannot take orders until a manager opens your register.',

  'learning.cashier.dashboard.title': 'Dashboard',
  'learning.cashier.dashboard.overview.title': 'POS Interface',
  'learning.cashier.dashboard.overview.content': 'The POS is split into Categories (left), Dishes (center), and the Current Order Ticket (right).',

  'learning.cashier.dailyWorkflow.title': 'Daily Workflow',
  'learning.cashier.dailyWorkflow.opening.title': 'Opening',
  'learning.cashier.dailyWorkflow.opening.content': 'Verify your cash drawer matches the starting amount set by the manager.',
  'learning.cashier.dailyWorkflow.taking.title': 'During Shift',
  'learning.cashier.dailyWorkflow.taking.content': 'Take direct orders, confirm waiter orders in the Orders tab, and manage tables.',
  'learning.cashier.dailyWorkflow.closing.title': 'Closing',
  'learning.cashier.dailyWorkflow.closing.content': 'Count your drawer and hand the cash to the manager/accountant to close the shift.',

  'learning.cashier.features.title': 'Features',
  'learning.cashier.features.pos.title': 'POS',
  'learning.cashier.features.pos.content': 'Tap items to add them. Select Dine-In, Takeaway, or Delivery. Apply discounts if authorized.',
  'learning.cashier.features.orders.title': 'Orders',
  'learning.cashier.features.orders.content': 'View all active orders. Pending orders from waiters appear here and require your confirmation.',
  'learning.cashier.features.tables.title': 'Tables',
  'learning.cashier.features.tables.content': 'View which tables are occupied and process payments for them.',
  'learning.cashier.features.scheduling.title': 'Scheduling',
  'learning.cashier.features.scheduling.content': 'If the kitchen runs out of an item, toggle it off here so it disappears from the POS and waiter tablets.',
  'learning.cashier.features.inventory.title': 'Inventory',
  'learning.cashier.features.inventory.content': 'View current stock levels to answer customer questions about availability.',

  'learning.cashier.commonTasks.title': 'Common Tasks',
  'learning.cashier.commonTasks.newOrder.title': 'Taking an Order',
  'learning.cashier.commonTasks.newOrder.content': 'Select order type, tap items, click Pay, enter received amount, and give change.',
  'learning.cashier.commonTasks.confirmWaiter.title': 'Confirming Waiter Orders',
  'learning.cashier.commonTasks.confirmWaiter.content': 'Go to Orders, find Pending orders, review items, and click Confirm to print kitchen tickets.',
  'learning.cashier.commonTasks.refund.title': 'Refunds',
  'learning.cashier.commonTasks.refund.content': 'Find the completed order in the Orders list and click Refund (requires authorization).',

  'learning.cashier.tips.title': 'Tips',
  'learning.cashier.tips.best.title': 'Speed Tips',
  'learning.cashier.tips.best.content': 'Use the search bar in the POS for quick item finding. Keep an eye on the Orders badge for new waiter requests.',
  'learning.cashier.tips.mistakes.title': 'Mistakes to Avoid',
  'learning.cashier.tips.mistakes.content': 'Forgetting to select a Delivery Zone for delivery orders, which results in incorrect total amounts.',

  'learning.cashier.faq.title': 'FAQ',
  'learning.cashier.faq.q1.title': 'Why is the screen yellow?',
  'learning.cashier.faq.q1.content': 'You are offline. You can still take orders. Do not close the app.',
  'learning.cashier.faq.q2.title': 'I get a Cash Register error.',
  'learning.cashier.faq.q2.content': 'Your shift is closed. Ask a manager to open it.',
  'learning.cashier.faq.q3.title': 'How do I add a note to a dish?',
  'learning.cashier.faq.q3.content': 'Click the dish in the current order ticket to open options and add notes like "No spicy".',

  'learning.cashier.troubleshooting.title': 'Troubleshooting',
  'learning.cashier.troubleshooting.offline.title': 'Offline Mode',
  'learning.cashier.troubleshooting.offline.content': 'If the printer stops working while offline, check the local network connection.',
  'learning.cashier.troubleshooting.registerClosed.title': 'Register Closed Mid-shift',
  'learning.cashier.troubleshooting.registerClosed.content': 'If a manager accidentally closes your shift, they must open a new one for you to continue.',

  'learning.cashier.whatsNew.title': 'What\'s New',
  'learning.cashier.whatsNew.latest.title': 'Updates',
  'learning.cashier.whatsNew.latest.content': 'New role-specific guides added.',

  // Accountant Content
  'learning.accountant.gettingStarted.title': 'Getting Started',
  'learning.accountant.gettingStarted.purpose.title': 'Your Role',
  'learning.accountant.gettingStarted.purpose.content': 'You oversee the financial health of the restaurant, reconcile cash, and manage expenses.',
  'learning.accountant.gettingStarted.firstLogin.title': 'First Steps',
  'learning.accountant.gettingStarted.firstLogin.content': 'Review the Dashboard to understand daily cash flow and pending reconciliations.',

  'learning.accountant.dashboard.title': 'Dashboard',
  'learning.accountant.dashboard.overview.title': 'Financial Overview',
  'learning.accountant.dashboard.overview.content': 'Quick view of today\'s revenue, expenses, and net profit.',

  'learning.accountant.dailyWorkflow.title': 'Daily Workflow',
  'learning.accountant.dailyWorkflow.morning.title': 'Morning',
  'learning.accountant.dailyWorkflow.morning.content': 'Open cash register shifts for cashiers with their starting float.',
  'learning.accountant.dailyWorkflow.during.title': 'During Shift',
  'learning.accountant.dailyWorkflow.during.content': 'Log operational expenses (vendor payments, utilities) as they occur.',
  'learning.accountant.dailyWorkflow.closing.title': 'Closing',
  'learning.accountant.dailyWorkflow.closing.content': 'Close cashier shifts, count physical cash, and review the daily P&L.',

  'learning.accountant.features.title': 'Features',
  'learning.accountant.features.dashboard.title': 'Dashboard',
  'learning.accountant.features.dashboard.content': 'High-level financial summaries.',
  'learning.accountant.features.expenses.title': 'Expenses',
  'learning.accountant.features.expenses.content': 'Record all outgoing money. Essential for accurate profit calculation.',
  'learning.accountant.features.cashRegister.title': 'Cash Register',
  'learning.accountant.features.cashRegister.content': 'Manage shifts. The system compares system-expected cash vs actual physical cash.',
  'learning.accountant.features.reports.title': 'Reports',
  'learning.accountant.features.reports.content': 'Generate P&L, End of Day, and tax reports. Exportable to PDF/Excel.',
  'learning.accountant.features.deliveryCompanies.title': 'Delivery Companies',
  'learning.accountant.features.deliveryCompanies.content': 'Manage commission rates so external orders calculate net revenue correctly.',
  'learning.accountant.features.orders.title': 'Orders',
  'learning.accountant.features.orders.content': 'View-only access to audit individual transactions.',
  'learning.accountant.features.inventory.title': 'Inventory',
  'learning.accountant.features.inventory.content': 'View-only access to audit inventory valuation and COGS.',

  'learning.accountant.commonTasks.title': 'Common Tasks',
  'learning.accountant.commonTasks.closeRegister.title': 'Reconciling a Shift',
  'learning.accountant.commonTasks.closeRegister.content': 'Click Close Shift, enter the counted cash. Note any shortages or overages.',
  'learning.accountant.commonTasks.addExpense.title': 'Logging an Expense',
  'learning.accountant.commonTasks.addExpense.content': 'Go to Expenses, click Add, select category, enter amount and attach receipt photo if needed.',
  'learning.accountant.commonTasks.generateReport.title': 'Generating P&L',
  'learning.accountant.commonTasks.generateReport.content': 'Go to Reports, select Profit & Loss, choose date range, and view net margin.',

  'learning.accountant.tips.title': 'Tips',
  'learning.accountant.tips.best.title': 'Best Practices',
  'learning.accountant.tips.best.content': 'Log expenses in real-time. Don\'t wait until the end of the month.',
  'learning.accountant.tips.mistakes.title': 'Mistakes to Avoid',
  'learning.accountant.tips.mistakes.content': 'Closing a shift without physically counting the drawer first.',

  'learning.accountant.faq.title': 'FAQ',
  'learning.accountant.faq.q1.title': 'Why is Net Profit lower than expected?',
  'learning.accountant.faq.q1.content': 'Ensure all COGS (Preparation Templates) are accurate and all Expenses are logged.',
  'learning.accountant.faq.q2.title': 'How are delivery commissions handled?',
  'learning.accountant.faq.q2.content': 'The system automatically deducts them from Revenue before calculating Net Profit.',

  'learning.accountant.troubleshooting.title': 'Troubleshooting',
  'learning.accountant.troubleshooting.mismatch.title': 'Cash Mismatches',
  'learning.accountant.troubleshooting.mismatch.content': 'If the drawer is short, review the cashier\'s refund and discount logs in the Reports section.',

  'learning.accountant.whatsNew.title': 'What\'s New',
  'learning.accountant.whatsNew.latest.title': 'Updates',
  'learning.accountant.whatsNew.latest.content': 'New accountant guides added.',

  // Inventory Manager Content
  'learning.inventoryManager.gettingStarted.title': 'Getting Started',
  'learning.inventoryManager.gettingStarted.purpose.title': 'Your Role',
  'learning.inventoryManager.gettingStarted.purpose.content': 'You ensure the restaurant never runs out of ingredients and track food costs accurately.',
  'learning.inventoryManager.gettingStarted.firstLogin.title': 'First Steps',
  'learning.inventoryManager.gettingStarted.firstLogin.content': 'Review current stock levels and check notifications for any negative stock anomalies.',

  'learning.inventoryManager.dailyWorkflow.title': 'Daily Workflow',
  'learning.inventoryManager.dailyWorkflow.morning.title': 'Morning',
  'learning.inventoryManager.dailyWorkflow.morning.content': 'Check Notifications for low stock alerts. Plan daily purchasing.',
  'learning.inventoryManager.dailyWorkflow.during.title': 'During Shift',
  'learning.inventoryManager.dailyWorkflow.during.content': 'Receive deliveries and update stock quantities in the system.',
  'learning.inventoryManager.dailyWorkflow.closing.title': 'Closing',
  'learning.inventoryManager.dailyWorkflow.closing.content': 'Review any stock anomalies (negative stock) generated during the day.',

  'learning.inventoryManager.features.title': 'Features',
  'learning.inventoryManager.features.materials.title': 'Inventory (Materials)',
  'learning.inventoryManager.features.materials.content': 'Manage all raw ingredients. Set cost per unit and low-stock threshold.',
  'learning.inventoryManager.features.restock.title': 'Restocking',
  'learning.inventoryManager.features.restock.content': 'Add newly purchased quantities to existing stock.',
  'learning.inventoryManager.features.templates.title': 'Preparation Templates',
  'learning.inventoryManager.features.templates.content': 'The most important feature. Link materials to menu dishes so stock deducts automatically when sold.',
  'learning.inventoryManager.features.notifications.title': 'Notifications',
  'learning.inventoryManager.features.notifications.content': 'Alerts for low stock and negative stock anomalies.',

  'learning.inventoryManager.commonTasks.title': 'Common Tasks',
  'learning.inventoryManager.commonTasks.addMaterial.title': 'Adding a Material',
  'learning.inventoryManager.commonTasks.addMaterial.content': 'Click Add Material. Define unit (KG, Box, Pc), cost, and alert threshold.',
  'learning.inventoryManager.commonTasks.restock.title': 'Restocking',
  'learning.inventoryManager.commonTasks.restock.content': 'Select a material, click Edit, and add the new quantity to the existing stock.',
  'learning.inventoryManager.commonTasks.fixAnomaly.title': 'Fixing Anomalies',
  'learning.inventoryManager.commonTasks.fixAnomaly.content': 'If stock goes negative, go to Notifications and click "Restock Shortages" to reset it to zero and record the missing cost.',

  'learning.inventoryManager.tips.title': 'Tips',
  'learning.inventoryManager.tips.best.title': 'Best Practices',
  'learning.inventoryManager.tips.best.content': 'Perform physical stock counts weekly to ensure system matches reality.',
  'learning.inventoryManager.tips.mistakes.title': 'Mistakes to Avoid',
  'learning.inventoryManager.tips.mistakes.content': 'Setting incorrect units in Preparation Templates (e.g. using 1 KG instead of 0.1 KG for a burger).',

  'learning.inventoryManager.faq.title': 'FAQ',
  'learning.inventoryManager.faq.q1.title': 'Why is stock not deducting?',
  'learning.inventoryManager.faq.q1.content': 'You probably haven\'t linked the material to the dish in Preparation Templates.',
  'learning.inventoryManager.faq.q2.title': 'What is Negative Stock?',
  'learning.inventoryManager.faq.q2.content': 'When a dish is sold but the system thinks you have 0 ingredients. It goes to -1 to alert you that you forgot to log a restock.',

  'learning.inventoryManager.troubleshooting.title': 'Troubleshooting',
  'learning.inventoryManager.troubleshooting.negative.title': 'Mass Negative Stock',
  'learning.inventoryManager.troubleshooting.negative.content': 'If many items are negative, review your purchasing logs. Use the Bulk Restock feature in Notifications.',

  'learning.inventoryManager.whatsNew.title': 'What\'s New',
  'learning.inventoryManager.whatsNew.latest.title': 'Updates',
  'learning.inventoryManager.whatsNew.latest.content': 'New inventory guides added.',

  // Delivery Cashier Content
  'learning.deliveryCashier.gettingStarted.title': 'Getting Started',
  'learning.deliveryCashier.gettingStarted.purpose.title': 'Your Role',
  'learning.deliveryCashier.gettingStarted.purpose.content': 'You manage incoming orders from 3rd party apps (Talabat, Toters, etc.) and ensure they are processed correctly.',
  'learning.deliveryCashier.gettingStarted.firstLogin.title': 'First Steps',
  'learning.deliveryCashier.gettingStarted.firstLogin.content': 'Familiarize yourself with the POS Delivery Companies tab.',

  'learning.deliveryCashier.dailyWorkflow.title': 'Daily Workflow',
  'learning.deliveryCashier.dailyWorkflow.receiving.title': 'Receiving Orders',
  'learning.deliveryCashier.dailyWorkflow.receiving.content': 'When an external tablet rings, enter the order into this system immediately.',
  'learning.deliveryCashier.dailyWorkflow.processing.title': 'Processing',
  'learning.deliveryCashier.dailyWorkflow.processing.content': 'Ensure the Order ID is entered correctly for tracking.',
  'learning.deliveryCashier.dailyWorkflow.tracking.title': 'Tracking',
  'learning.deliveryCashier.dailyWorkflow.tracking.content': 'Monitor the Delivery Orders page to dispatch drivers.',

  'learning.deliveryCashier.features.title': 'Features',
  'learning.deliveryCashier.features.pos.title': 'POS',
  'learning.deliveryCashier.features.pos.content': 'Used to input the orders. Select the correct delivery company tab.',
  'learning.deliveryCashier.features.deliveryOrders.title': 'Delivery Orders',
  'learning.deliveryCashier.features.deliveryOrders.content': 'Manage dispatching and driver assignment.',

  'learning.deliveryCashier.commonTasks.title': 'Common Tasks',
  'learning.deliveryCashier.commonTasks.newDeliveryOrder.title': 'Entering an Order',
  'learning.deliveryCashier.commonTasks.newDeliveryOrder.content': 'Open POS > Select Company > Enter Order ID > Add Items > Confirm.',
  'learning.deliveryCashier.commonTasks.trackOrder.title': 'Dispatching',
  'learning.deliveryCashier.commonTasks.trackOrder.content': 'Go to Delivery Orders and update status when the driver picks up the food.',

  'learning.deliveryCashier.tips.title': 'Tips',
  'learning.deliveryCashier.tips.best.title': 'Speed',
  'learning.deliveryCashier.tips.best.content': 'Enter orders exactly as they appear on the external tablet to ensure kitchen accuracy.',
  'learning.deliveryCashier.tips.mistakes.title': 'Mistakes to Avoid',
  'learning.deliveryCashier.tips.mistakes.content': 'Entering a delivery order as a regular Dine-In order. This messes up accounting commissions.',

  'learning.deliveryCashier.faq.title': 'FAQ',
  'learning.deliveryCashier.faq.q1.title': 'Why must I select the company?',
  'learning.deliveryCashier.faq.q1.content': 'So the system can automatically calculate their commission and show our true profit.',

  'learning.deliveryCashier.troubleshooting.title': 'Troubleshooting',
  'learning.deliveryCashier.troubleshooting.companyMissing.title': 'Company Not Listed',
  'learning.deliveryCashier.troubleshooting.companyMissing.content': 'If a delivery app is missing from the POS, ask the Manager to add it in Settings > Delivery Companies.',

  'learning.deliveryCashier.whatsNew.title': 'What\'s New',
  'learning.deliveryCashier.whatsNew.latest.title': 'Updates',
  'learning.deliveryCashier.whatsNew.latest.content': 'New delivery cashier guides added.',
  'sidebar.learning': 'Learning Center'
};

export default en;
